import { useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors, OpenInNewIcon } from "@dotnet/telematics-design-system";

import CompanyLevelDialog from "components/CompanyLevel";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { svgFontSize } from "shared/styles/styleFunctions";
import { body3Regular } from "shared/styles/typography";
import { COMPANY_LEVELS } from "shared/types/enums";

import { LevelProps } from "./types";

const Level = ({ level }: LevelProps) => {
    const { beigeDefault, gray200, gray700, gray800, gray900 } = colors;

    const { t } = useTranslation();

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const openDialog = () => setIsDialogOpen(true);
    const closeDialog = () => setIsDialogOpen(false);

    const getBgColor = () => {
        switch (level) {
            case COMPANY_LEVELS.Premium:
                return gray800;
            case COMPANY_LEVELS.Standard:
                return beigeDefault;
            default:
                return gray200;
        }
    };

    return (
        <div
            css={css({
                display: "flex"
            })}
        >
            <div
                css={css({
                    width: "4px",
                    borderRadius: "2px",
                    background: getBgColor()
                })}
            />

            <div
                css={css({
                    padding: "10px 0 10px 8px"
                })}
            >
                <div
                    css={css({
                        display: "flex",
                        alignItems: "center",
                        color: gray900,
                        fontSize: "20px",
                        fontWeight: "500",
                        lineHeight: "24px",
                        letterSpacing: "0.15px",
                        marginBottom: "4px",

                        "& > svg": {
                            cursor: "pointer",
                            marginLeft: "4px",
                            ...svgFontSize(16)
                        }
                    })}
                >
                    {level}

                    <TooltipGeneral
                        placement={TOOLTIP_PLACEMENT.Top}
                        title={t("General##click for more details")}
                    >
                        <OpenInNewIcon onClick={openDialog} />
                    </TooltipGeneral>

                    <CompanyLevelDialog
                        isOpen={isDialogOpen}
                        close={closeDialog}
                    />
                </div>

                <div css={[body3Regular, { color: gray700 }]}>
                    {t(`Dashboard##company level##description##${level}`)}
                </div>
            </div>
        </div>
    );
};

export default Level;
